import { Component } from '@angular/core';

@Component({
    selector: 'ifp-broker-user-dummy',
    templateUrl: './broker-user-dummy.component.html',
    standalone: false
})
export class BrokerUserDummyComponent {}
